// extracted by mini-css-extract-plugin
module.exports = {"captchaContainer":"CaptchaGoogle_captchaContainer__2RiT1"};